export default {
    VERY_SAD: '1',
    SAD: '2',
    NEUTRAL: '3',
    HAPPY: '4',
    VERY_HAPPY: '5',
};
